"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class DcChargePoint extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dcChargePoint';
        this._available = initParams.available;
        this._chargeStationId = initParams.charge_station_id;
        this._code = initParams.code;
    }
    set available(value) {
        console.error('Do not set objects this way');
    }
    get available() {
        return this._available;
    }
    set chargeStationId(value) {
        console.error('Do not set objects this way');
    }
    get chargeStationId() {
        return this._chargeStationId;
    }
    set code(value) {
        console.error('Do not set objects this way');
    }
    get code() {
        return this._code;
    }
}
exports.default = DcChargePoint;
//# sourceMappingURL=dcChargePoint.js.map